<template>
  <div class="github-widget">
    <widget-link
      v-for="repo in reposList"
      :key="repo.id"
      :item="repo"
      title-bold
    ></widget-link>
  </div>
</template>

<script>

import WidgetLink from '~/components/menu/WidgetLink'

export default {
  name: 'GithubWidget',
  components: {WidgetLink},
  async fetch() {
    this.repos = await fetch(`https://api.github.com/users/selectel/repos?sort=pushed&direction=desc&per_page=6`)
      .then(res => res.json())
  },
  fetchOnServer: false,
  data() {
    return {
      repos: []
    }
  },
  computed: {
    reposList() {
      if (this.repos.length > 0) {
        const reposList = []

        this.repos.forEach(repo => {
          reposList.push({
            title: repo.name,
            externalTypeOfLink: true,
            url: {
              path: repo.html_url,
              hash: null
            },
            labels: [
              {
                iconName: 'link',
                name: repo.language
              },
              {
                iconName: 'clock',
                name: `Upd: ${this.formatDate(repo.updated_at)}`
              }
            ],
            description: repo.description
          })
        })

        return reposList
      }

      return []
    }
  },
  methods: {
    formatDate(str) {
      return new Intl.DateTimeFormat('ru-RU', {
        month: 'numeric', day: 'numeric'
      })
        .format(new Date(str))
    }
  }
}
</script>

<style lang="scss">
  .github-widget {
    .nav-dropdown__widgets--alone & {
      display: grid;
      grid-template-columns: repeat(3, minmax(160px, 1fr));
      grid-column-gap: 32px;

      @media (max-width: $breakpoint-xl) {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
</style>